Ext.define('SA.view.sidebar.SectionHeader', {
    alias: 'widget.sidebar-section-header',
    extend: 'Ext.Component',

    baseCls: 'sa-sidebar-section-header',

    beforeRender() {
        this.protoEl.unselectable();

        if (Array.isArray(this.html)) {
            this.html = this.html.join('');
        }

        this.callParent();
    },

    initEvents() {
        this.callParent();

        if (this.handler) {
            this.el.on('click', this.handler, this);
        }
    }
});